import React, { useState, useEffect } from "react";
import { listMeals } from "../../api/OtterApi";
import { useAuth0 } from "@auth0/auth0-react";

import SearchBar from "../../components/searchbar/SearchBar";
import "./MealPage.css";
import SearchResultGallery from "../../components/searchbar/gallery/SearchResultGallery";
import * as GrIcons from "react-icons/gr";

const MealPage = () => {
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [meals, setMeals] = useState([]);
    const [hasNext, setHasNext] = useState(false);
    const [searchText, setSearchText] = useState("");
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        const getMeals = async () => {
            const token = await getAccessTokenSilently();
            const response = await listMeals(
                token,
                limit,
                offset,
                searchText.trim()
            );
            if (response.status === 200) {
                const rawMeals = response.data.meals;
                if (rawMeals.length === 0) {
                    setOffset(0);
                } else {
                    setMeals(rawMeals);
                }
            } else {
                console.error(response.data.error);
            }
        };
        getMeals();
    }, [searchText, limit, offset]);

    useEffect(() => {
        const checkHasNext = async () => {
            const token = await getAccessTokenSilently();
            const response = await listMeals(
                token,
                1,
                offset + limit + 1,
                searchText.trim()
            );
            if (response.status === 200) {
                const rawMeals = response.data.meals;
                setHasNext(rawMeals && rawMeals.length > 0);
            } else {
                console.error(response.data.error);
            }
        };
        checkHasNext();
    }, [meals]);

    const handlePrevClick = () => {
        setOffset(Math.max(0, offset - limit));
    };

    const handleNextClick = () => {
        setOffset(offset + limit);
    };

    return (
        <div className="meal-page-container">
            <SearchBar searchText={searchText} setSearchText={setSearchText} />
            <SearchResultGallery
                title={"Meals"}
                resource={"meal"}
                results={meals}
            />
            <div className="meal-search-page-controls">
                <div className="page-prev-button" onClick={handlePrevClick}>
                    {offset > 0 ? <GrIcons.GrPrevious /> : ""}
                </div>
                <div className="page-next-button" onClick={handleNextClick}>
                    {hasNext ? <GrIcons.GrNext /> : ""}
                </div>
            </div>
        </div>
    );
};

export default MealPage;
